module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"951\" height=\"840\"><path fill-rule=\"evenodd\" d=\"M0 150.374C237.471 50.124 406.255 0 506.35 0 656.493 0 964.01 161.316 950.125 385.008 940.869 534.135 775.152 652.466 452.974 740L0 840V150.374z\"/></svg>"


//////////////////
// WEBPACK FOOTER
// /www/client/src/components/Icon/twitter-blob.svg
// module id = 785
// module chunks = 0